import { AxiosInstance } from 'axios';
import { Paginated } from '../../interfaces/Paginated';
import { Entity } from '../../interfaces/Entity';
import { EntityMetadata as Metadata } from '../../interfaces/EntityMetadata';

export const getEntityData = async (
  axios: AxiosInstance,
  url: string
): Promise<Paginated<Entity>> => {
  const { data } = await axios.get<Paginated<Entity>>(url);
  return data;
};

export const getDocumentDataById = async (
  axios: AxiosInstance,
  entityName: string,
  documentId: string
): Promise<Entity> => {
  const { data } = await axios.get<Entity>(
    `Entity/${entityName}/document/${documentId}`
  );
  return data;
};

export const getMetadata = async (
  axios: AxiosInstance
): Promise<Metadata[]> => {
  const { data } = await axios.get<Metadata[]>('Metadata');
  return data;
};

export const getMetadataByEntityName = async (
  axios: AxiosInstance,
  entityName: string
): Promise<Metadata | undefined> => {
  const metadata = await getMetadata(axios);
  if (metadata.length) {
    return metadata.find((meta) => meta.name === entityName);
  }
  return undefined;
};
